module.exports = __webpack_public_path__ + "img/title-bg.5fd1276a.png";